import { render, staticRenderFns } from "./Modales.vue?vue&type=template&id=5ca5b78e&"
import script from "./Modales.vue?vue&type=script&lang=js&"
export * from "./Modales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports